export default __webpack_public_path__ + "static/55-ca60d34145b28a454b3fb2ee90f5aa15.png";